import { gql } from "@apollo/client";

export const CREATE_VIRTUAL_ACCOUNT_DAILY_SNAPSHOT_DOWNLOAD_TASK = gql`
    mutation CreateVirtualAccountDailySnapshotDownloadTask($filters: VirtualAccountDailySnapshotFilterTypeInput) {
        createVirtualAccountDailySnapshotDownloadTask(filters: $filters) {
            success
            message
            messageKey
            data
        }
    }
`;

export interface VirtualAccountDailySnapshotDownloadTaskResponse {
    createVirtualAccountDailySnapshotDownloadTask: {
        success: boolean;
        message?: string | null;
        messageKey?: string | null;
        data?: string | null;
    };
}

